
import { pathOr, pluck, zipObj } from 'ramda';

const mapTranslationData = (data, traslationsId) => {
  const items = pathOr([], ['translationCollection', 'items'], data);
  const main = items.find(i => i?.title === traslationsId);
  const translations = pathOr([], ['childrenCollection', 'items'], main);

  const keys = pluck('key')(translations);
  const values = pluck('value')(translations);

  return zipObj(keys, values);
};

export { mapTranslationData };
